import React from 'react';
import { TASK_UNIVERSES, type TaskUniverse } from '../constants/taskCreation';

interface Props {
  selected: TaskUniverse | '';
  onSelect: (id: TaskUniverse) => void;
}

const UniversePicker: React.FC<Props> = ({ selected, onSelect }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
      {TASK_UNIVERSES.map((u) => {
        const isActive = selected === u.id;
        return (
          <button
            key={u.id}
            type="button"
            onClick={() => onSelect(u.id)}
            className="group relative flex flex-col items-center gap-2 p-4 rounded-2xl border-2 transition-all duration-300 text-center outline-none focus-visible:ring-2 focus-visible:ring-tech-cyan"
            style={{
              borderColor: isActive ? u.color : 'rgba(255,255,255,0.08)',
              background: isActive
                ? `linear-gradient(145deg, ${u.glow}, rgba(10,10,10,0.95))`
                : 'rgba(26,26,26,0.6)',
              boxShadow: isActive ? `0 0 28px ${u.glow}, 0 0 0 1px ${u.color}40` : 'none',
              transform: isActive ? 'scale(1.04)' : 'scale(1)',
            }}
          >
            {/* glow ring on hover */}
            <span
              className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
              style={{ boxShadow: `inset 0 0 24px ${u.glow}` }}
            />
            <span className="text-3xl sm:text-4xl relative z-10 transition-transform duration-300 group-hover:scale-110">
              {u.emoji}
            </span>
            <span
              className="text-sm font-bold relative z-10 transition-colors"
              style={{ color: isActive ? u.color : '#e8eaed' }}
            >
              {u.label}
            </span>
            <span className="text-[11px] leading-tight text-tech-text-muted relative z-10">
              {u.subtitle}
            </span>
            {/* selected check */}
            {isActive && (
              <span
                className="absolute top-2 right-2 w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold animate-fade-in"
                style={{ background: u.color, color: '#0a0a0a' }}
              >
                ✓
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default UniversePicker;
